export default function BrandLogo({size=36}:{size?:number}){
 return <svg viewBox="0 0 64 64" width={size} height={size} role="img" aria-label="Logotipo de EduVirtual Lab"><path d="M12 51 32 12 52 51Z" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinejoin="round"/><circle cx="32" cy="12" r="5.5" fill="#fb923c"/></svg>;
}
